import React, { useEffect, useRef, useState } from "react";
import { IconButton } from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import { AppLauncher } from "@oruclick/header-popup";
import "@oruclick/header-popup/style.css";
import { fetchUserProducts } from "../../../Action/api";
import { getAuthTokenPayload } from "../../../Utils";
import { API_USER_AUTH_URL } from "../../../Config";

// OruClick suite app switcher. All filtering/sorting/coloring of the apps grid,
// and the per-app single-sign-on token exchange on tile click, is owned by
// @oruclick/header-popup itself - this component only fetches the raw
// user-product API response and hands it to the package unmodified.
const AppSwitcher = ({ isMobile }) => {
  const [userProduct, setUserProduct] = useState(null);
  const appsButtonRef = useRef(null);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return;
    const loadUserProducts = async () => {
      const result = await fetchUserProducts();
      if (result.success) setUserProduct(result.data);
    };
    loadUserProducts();
  }, []);

  // showAppIcon is a backend-driven kill switch for the whole launcher, and we
  // need our own guard here (not just the package's internal one) since we're
  // rendering our own trigger button via anchorRef rather than the package's
  // built-in one.
  if (!userProduct || userProduct.showAppIcon === false || !userProduct.apps) {
    return null;
  }

  // This session's own app, from the JWT - highlights it in the grid and makes
  // clicking it just close the popup instead of opening a duplicate tab.
  const activeId = getAuthTokenPayload()?.loginApp?.productId;

  return (
    <>
      <IconButton
        ref={appsButtonRef}
        color="inherit"
        aria-label="OruClick apps"
        size={isMobile ? "small" : "medium"}
        sx={{
          transition: "all 0.3s ease-in-out",
          background: "rgba(0,0,0,0.04)",
          "&:hover": {
            transform: "scale(1.05)",
            background: "rgba(0,0,0,0.08)",
          },
        }}
      >
        <AppsIcon fontSize={isMobile ? "small" : "medium"} />
      </IconButton>
      <AppLauncher
        apps={userProduct.apps}
        activeId={activeId}
        authToken={() => localStorage.getItem("authToken")}
        tokenUrl={`${API_USER_AUTH_URL}/user-auth/product`}
        anchorRef={appsButtonRef}
      />
    </>
  );
};

export default AppSwitcher;
